import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const educationDescriptor = defineListFilter({
  definition: {
    id: FilterId.EDUCATION,
    name: 'Education',
    selectionListId: 'highest_degree',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_EDUCATION },
});
